module.exports = {
	"ha": "nha",
	"id": 5.5,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by Age Category and MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "50%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "50%",
				"height": "50%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -100,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#043f61"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#0c4250"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#0d4440"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#09472e"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#043f61"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0c4250"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0d4440"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#09472e"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#043f61"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0c4250"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0d4440"
					},
					{
						"y": 62.5,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#09472e"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 92.3076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#043f61"
					},
					{
						"y": 73.07692307692307,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0c4250"
					},
					{
						"y": 73.07692307692307,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0d4440"
					},
					{
						"y": 65.38461538461539,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#09472e"
					},
					{
						"y": 38.46153846153847,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#043f61"
					},
					{
						"y": 42.857142857142854,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0c4250"
					},
					{
						"y": 42.857142857142854,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0d4440"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#09472e"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.55172413793103,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#043f61"
					},
					{
						"y": 96.55172413793103,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#0c4250"
					},
					{
						"y": 93.10344827586206,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#0d4440"
					},
					{
						"y": 51.724137931034484,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#09472e"
					},
					{
						"y": 20.689655172413794,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96,
						"dataLabels": {
							"enabled": false,
							"format": "48"
						},
						"color": "#043f61"
					},
					{
						"y": 84,
						"dataLabels": {
							"enabled": false,
							"format": "42"
						},
						"color": "#0c4250"
					},
					{
						"y": 82,
						"dataLabels": {
							"enabled": false,
							"format": "41"
						},
						"color": "#0d4440"
					},
					{
						"y": 66,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#09472e"
					},
					{
						"y": 30,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 93.90243902439023,
						"dataLabels": {
							"enabled": false,
							"format": "77"
						},
						"color": "#043f61"
					},
					{
						"y": 89.02439024390245,
						"dataLabels": {
							"enabled": false,
							"format": "73"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.58536585365853,
						"dataLabels": {
							"enabled": false,
							"format": "71"
						},
						"color": "#0d4440"
					},
					{
						"y": 79.26829268292683,
						"dataLabels": {
							"enabled": false,
							"format": "65"
						},
						"color": "#09472e"
					},
					{
						"y": 51.21951219512195,
						"dataLabels": {
							"enabled": false,
							"format": "42"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 46.15384615384615,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#043f61"
					},
					{
						"y": 46.15384615384615,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0c4250"
					},
					{
						"y": 46.15384615384615,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0d4440"
					},
					{
						"y": 38.46153846153847,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#09472e"
					},
					{
						"y": 23.076923076923077,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 86.66666666666667,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#043f61"
					},
					{
						"y": 73.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0c4250"
					},
					{
						"y": 73.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0d4440"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#09472e"
					},
					{
						"y": 53.333333333333336,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.11764705882352,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#043f61"
					},
					{
						"y": 70.58823529411765,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0c4250"
					},
					{
						"y": 58.82352941176471,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0d4440"
					},
					{
						"y": 47.05882352941176,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#09472e"
					},
					{
						"y": 29.411764705882355,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 87.5,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#043f61"
					},
					{
						"y": 70,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#0c4250"
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#0d4440"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#09472e"
					},
					{
						"y": 42.5,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -100,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -42.85714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.833333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.526315789473683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -41.17647058823529,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -50,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -100,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -44.44444444444444,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -60,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.0000000000000036,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.3809523809523836,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.512195121951216,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -54.54545454545454,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.0975609756097615,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.1948051948051965,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.73972602739726,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.450704225352112,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.38461538461538,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -53.84615384615385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -13.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.384615384615385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.166666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=2"
			},
			{
				"x": 9,
				"text": "30-39<br>n=7"
			},
			{
				"x": 15,
				"text": "40-49<br>n=8"
			},
			{
				"x": 21,
				"text": ">=50<br>n=26"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=7"
			},
			{
				"x": 34,
				"text": "30-39<br>n=29"
			},
			{
				"x": 40,
				"text": "40-49<br>n=50"
			},
			{
				"x": 46,
				"text": ">=50<br>n=82"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=13"
			},
			{
				"x": 59,
				"text": "30-39<br>n=15"
			},
			{
				"x": 65,
				"text": "40-49<br>n=17"
			},
			{
				"x": 71,
				"text": ">=50<br>n=40"
			}
		],
		"dataTable": {
			"MSM:<30": [
				2,
				2,
				0,
				0,
				0,
				0
			],
			"MSM:30-39": [
				7,
				7,
				4,
				4,
				4,
				4
			],
			"MSM:40-49": [
				8,
				8,
				6,
				6,
				5,
				4
			],
			"MSM:>=50": [
				26,
				24,
				19,
				19,
				17,
				10
			],
			"Non-MSM:<30": [
				7,
				6,
				3,
				3,
				0,
				0
			],
			"Non-MSM:30-39": [
				29,
				28,
				28,
				27,
				15,
				6
			],
			"Non-MSM:40-49": [
				50,
				48,
				42,
				41,
				33,
				15
			],
			"Non-MSM:>=50": [
				82,
				77,
				73,
				71,
				65,
				42
			],
			"Unknown:<30": [
				13,
				6,
				6,
				6,
				5,
				3
			],
			"Unknown:30-39": [
				15,
				13,
				11,
				11,
				10,
				8
			],
			"Unknown:40-49": [
				17,
				16,
				12,
				10,
				8,
				5
			],
			"Unknown:>=50": [
				40,
				35,
				28,
				26,
				24,
				17
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_5_5.json
// module id = 272
// module chunks = 0